/*
 * @Author: zhouwei
 * @Date: 2019-11-07 10:11:37
 * @Last Modified by: zhouwei
 * @Last Modified time: 2019-12-02 01:58:38
 * @Desc: 公司参与
*/
<template>
  <div class="partake">
    <div class="title">
      <h3>销售参与情况</h3>
      <span>应结算金额（元）</span>
    </div>
    <div class="content">
      <ul
        v-if="propData.length > 0"
        v-infinite-scroll="load"
        class="infinite-list"
        :infinite-scroll-immediate="false"
      >
        <li
          v-for="(item,index) in propData"
          :key="index"
          class="infinite-list-item"
        >
          <div class="sale">
            <span>{{ item.name }}</span>
          </div>
          <span class="phone">{{ item.phone }}</span>
          <span class="num">{{ item.attachCount }}</span>
        </li>
      </ul>
      <div
        v-else
        class="no-data"
      >
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propData: {
      type: Array,
      default () {
        return [
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          },
          {
            name: 1,
            phone: '11111',
            attachCount: 2
          }
        ]
      }
    }
  },
  methods: {
    load () {
      this.$emit('load')
    },
    handleStyle (index) {
      if (index === 0) {
        return {
          color: '#ad6800',
          backgroundColor: '#fadb14'
        }
      } else if (index === 1) {
        return {
          color: '#333333',
          backgroundColor: '#e8e8e8'
        }
      } else if (index === 2) {
        return {
          color: '#b48c7d',
          backgroundColor: '#cca692'
        }
      } else {
        return {
          color: '#fff',
          backgroundColor: '#bfbfbf'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.partake {
  width: 100%;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    box-sizing: border-box;
    background-color: #fafafa;

    h3 {
      font-size: 14px;
      color: #262626;
      font-weight: 500;
      margin-left: 20px;
    }

    span {
      color: #8c8c8c;
      font-size: 12px;
      margin-right: 10px;
    }
  }

  .content {
    ul {
      max-height: 425px;
      overflow: auto;

      li {
        border-top: 1px solid #d9d9d9;
        display: flex;
        height: 50px;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;

        .num {
          color: #595959;
          margin-right: 30px;
        }

        .sale {
          margin-left: 20px;

          span {
            display: block;
            font-size: 14px;
            line-height: 14px;
            font-weight: 500;
          }
        }
      }
    }

    .no-data {
      text-align: center;
      font-size: 14px;
      line-height: 14px;
      padding: 16px 0;
      color: #bfbfbf;
    }
  }
}
</style>
